import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="w-full bg-white shadow-sm fixed top-0 left-0 right-0 z-50" data-id="element-105">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-106">
        <div className="flex items-center" data-id="element-107">
          <h1 className="text-2xl font-bold text-blue-700" data-id="element-108">量盛科技</h1>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-109">
          <a href="#home" className="text-gray-800 hover:text-blue-700 font-medium" data-id="element-110">
            首页
          </a>
          <a href="#business" className="text-gray-800 hover:text-blue-700 font-medium" data-id="element-111">
            业务范围
          </a>
          <a href="#about" className="text-gray-800 hover:text-blue-700 font-medium" data-id="element-112">
            关于我们
          </a>
          <a href="#contact" className="text-gray-800 hover:text-blue-700 font-medium" data-id="element-113">
            联系我们
          </a>
        </nav>
        {/* Mobile menu button */}
        <div className="md:hidden" data-id="element-114">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-800 hover:text-blue-700 focus:outline-none" data-id="element-115">
            {isMenuOpen ? <XIcon size={24} data-id="element-116" /> : <MenuIcon size={24} data-id="element-117" />}
          </button>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white shadow-lg" data-id="element-118">
          <div className="container mx-auto px-4 py-2 flex flex-col space-y-3" data-id="element-119">
            <a href="#home" className="text-gray-800 hover:text-blue-700 py-2 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-120">
              首页
            </a>
            <a href="#business" className="text-gray-800 hover:text-blue-700 py-2 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-121">
              业务范围
            </a>
            <a href="#about" className="text-gray-800 hover:text-blue-700 py-2 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-122">
              关于我们
            </a>
            <a href="#contact" className="text-gray-800 hover:text-blue-700 py-2 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-123">
              联系我们
            </a>
          </div>
        </div>}
    </header>;
}